export enum EventError {
    ALL_CLEAR = 0,
    DATA_MISSING = 1,
    UNPUBLISHED = 2,
    UNATTENDED = 3,
    LOADING_ERROR = 4,
    INELIGIBLE = 5,
}
